'use client';
import React from 'react';

import { FeedbackFormContext } from './FeedbackFormContext';

const FeedbackFormContextProvider = ({ children, entityId, entityType }) => {
  const [thumbState, setThumbState] = React.useState<null | string>(null);
  const [isUnfolded, setUnfoldState] = React.useState<boolean>(false);
  const [isSent, setIsSent] = React.useState<boolean>(false);
  const [isNoticeOpen, setIsNoticeOpen] = React.useState<boolean>(false);

  const closeAction = React.useCallback(() => {
    setUnfoldState(false);
  }, []);

  const openAction = React.useCallback(() => {
    setUnfoldState(true);
  }, []);

  return (
    <FeedbackFormContext.Provider
      value={{
        thumbState,
        setThumbState,
        isUnfolded,
        // setUnfoldState,
        isSent,
        setIsSent,
        isNoticeOpen,
        setIsNoticeOpen,
        entityId,
        entityType,
        closeAction,
        openAction,
      }}
    >
      {children}
    </FeedbackFormContext.Provider>
  );
};

export { FeedbackFormContext, FeedbackFormContextProvider };
